import React from 'react';

export default function ProductCatalogSummary({
  productName,
  eyebrow,
  title,
  imageSrc,
  items = [],
}) {
  return (
    <section
      className={`product-catalog-summary${items.length ? '' : ' product-catalog-summary--image-only'}`}
      aria-labelledby={`${productName}-catalog-title`}
    >
      <div className="hicps-container product-catalog-summary-inner">
        <header className="product-catalog-summary-copy">
          {eyebrow && (
            <span className="product-catalog-summary-kicker">{eyebrow}</span>
          )}

          <h2 id={`${productName}-catalog-title`}>
            {title}
          </h2>
        </header>

        <figure className="product-catalog-summary-visual">
          <img
            src={imageSrc}
            alt={`${productName} - ${title}`}
            loading="eager"
            decoding="async"
          />
        </figure>

        {items.length > 0 && (
          <div className="product-catalog-summary-grid">
            {items.map((item, index) => (
              <article
                key={item.title}
                className="product-catalog-summary-item"
              >
                <div
                  className="product-catalog-summary-number"
                  aria-hidden="true"
                >
                  {String(index + 1).padStart(2, '0')}
                </div>

                <div>
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
